"use strict";

exports.__esModule = true;
var _ComponentRemainingLifeElement = require("./ComponentRemainingLifeElement");
Object.keys(_ComponentRemainingLifeElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComponentRemainingLifeElement[key]) return;
  exports[key] = _ComponentRemainingLifeElement[key];
});
var _ComponentRemainingLifeFields = require("./ComponentRemainingLifeFields");
Object.keys(_ComponentRemainingLifeFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComponentRemainingLifeFields[key]) return;
  exports[key] = _ComponentRemainingLifeFields[key];
});
var _ComponentRemainingLifeThumbnail = require("./ComponentRemainingLifeThumbnail");
Object.keys(_ComponentRemainingLifeThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComponentRemainingLifeThumbnail[key]) return;
  exports[key] = _ComponentRemainingLifeThumbnail[key];
});
var _ComponentRemainingLifeHeader = require("./ComponentRemainingLifeHeader");
Object.keys(_ComponentRemainingLifeHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComponentRemainingLifeHeader[key]) return;
  exports[key] = _ComponentRemainingLifeHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});